import { Button, ButtonGroup, Card, Dialog, DialogContent, Divider, Grid, IconButton, Skeleton, Stack, TextField, Typography, Link, Paper, CardHeader, CardContent } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import { useState } from "react";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { useGetOrderActionsQuery } from '../features/model/orderSlice';
import Loading from './Loading';
import { useCreateActionMutation, useGetActionPhotosQuery, useUpdateActionMutation } from '../features/model/actionSlice';
import PhotoUpload from './PhotoUpload';
import { DateTimePicker } from '@mui/x-date-pickers';
import { useSendPurchaseOrderActionMutation, useUpdatePurchaseOrderDataMutation } from '../features/po/poSlice';
import dayjs, { utc } from 'dayjs';
import { useDeletePhotoMutation } from '../features/model/photoSlice';
dayjs.extend(utc);

const HistoryImageTools = ({image}) => {
  const [deletePhoto] = useDeletePhotoMutation();
  return <Stack direction="column">
    <IconButton color="primary" onClick={() => {
      deletePhoto(image.id);
    }}><DeleteIcon /></IconButton>
  </Stack>
}

const HistoryItemImage = ({history_image, width, editable=false}) => {
  const [showDialog, setShowDialog] = useState(false);
  const showFullImage = () => {
    setShowDialog(true)
  }
  const hideFullImage = () => {
    setShowDialog(false)
  }

  // a pdf?
  let meta = JSON.parse(history_image.metadata);
  
  if (meta.format || "" === "pdf") {
    return <Stack direction="row">
      <Link target="_blank" href={`${process.env.REACT_APP_API_URL}v1/download/pdf/${history_image.identifier}`}>
        <img alt={history_image.identifier} src={`${process.env.REACT_APP_API_URL}/v1/download/thumb/${history_image.identifier}/${width}`} />
      </Link>
      {editable && <HistoryImageTools image={history_image} />}
    </Stack>
  }

  return <Stack direction="row">
    <img alt={history_image.identifier} src={`${process.env.REACT_APP_API_URL}/v1/download/thumb/${history_image.identifier}/${width}`} onClick={showFullImage}/>
    {editable && <HistoryImageTools image={history_image} />}
    <Dialog fullScreen key={`full_${history_image.identifier}`} open={showDialog} onClose={hideFullImage}>
      <IconButton aria-label="close" onClick={hideFullImage} sx={{position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500],}}>
          <CloseIcon />
      </IconButton>
      <DialogContent>
        <img alt={history_image.identifier} src={`${process.env.REACT_APP_API_URL}/v1/download/jpeg/${history_image.identifier}`}/>
      </DialogContent>
    </Dialog>
  </Stack>
}

const HistoryItemImages = ({history_item, editable=false}) => {

  const {data: action_images, error, imagesIsLoading, refetch} = useGetActionPhotosQuery(history_item.id)

  if (imagesIsLoading) {
    return <Skeleton variant="rectangular" width={210} height={60} />
  }
  if (error || !action_images) {
    return <></>;
  }
  return <Stack direction="column">
    <Grid container>
      <Grid item>
        {action_images.objects.map((action_image, i) =>
          <HistoryItemImage history_image={action_image} width={210} key={`hii_${action_image.identifier}`} editable={editable}/>
        )}
      </Grid>
    </Grid>
    <PhotoUpload order_id={history_item.order} action_id={history_item.id} onUploaded={(() => {
      //refetch();
    })}/>
    </Stack>
}

const HistoryItemCard = ({history_item}) => {
  const [editing, setEditing] = useState(false);
  const [status, setStatus] = useState(history_item.data);
  const [datetime, setDatetime] = useState(utc(history_item.timestamp).local());
  const [notify, {isUpdating, isSuccess, isError}] = useSendPurchaseOrderActionMutation();
  const [update] = useUpdateActionMutation();

  return <Paper>
    <Card sx={{padding: 1, minHeight: 100}}>
      {editing ? 
      <></>
      :
      <CardHeader title={history_item.data} sx={{padding: 1}} titleTypographyProps={{variant: "h3"}} subheader={dayjs.utc(history_item.timestamp).local().format('YYYY-MM-DD HH:mm:ss')}
        action={
          <IconButton aria-label="edit" onClick={() => {
            setEditing(!editing);
          }}>
            <EditIcon />
          </IconButton>
        }
      />
      }
      <CardContent>
      <Stack direction={"column"} spacing={2}>
        { editing ? 
        <Stack direction="column" spacing={.5}>
          <TextField label="Status" value={status} onChange={(e) => {setStatus(e.target.value)}} />
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateTimePicker value={datetime} onChange={(e) => setDatetime(e)}/>
          </LocalizationProvider>
          <Button variant="outlined" onClick={async () => {
            update({action_id: history_item.id, data: {data: status, timestamp: datetime.toJSON()}});
            setEditing(!editing);
          }}>Save changes</Button>
        </Stack>
        : <></>}
        <Stack sx={{minWidth: 250}}>
          <Button variant="outlined" onClick={() => {notify(history_item.id)}} disabled={isUpdating} >Notify</Button>
          <Typography variant="body1">{isSuccess ? "Notification sent!" : (isError ? "Notification failed!" : "")}</Typography>
        </Stack>
        <Divider orientation="vertical" flexItem></Divider>
        <HistoryItemImages history_item={history_item} editable={true}/>
      </Stack>
      </CardContent>
    </Card>
  </Paper>
}

const NewHistoryItemCard = (order) => {
  const [state, setState] = useState({"status": "", "timestamp": ""});
  const [createAction, {isLoadingUpdate: isUpdating}] = useCreateActionMutation();
  const [datetime, setDatetime] = useState(dayjs());
  const updateStatus = (e) => {
    setState({...state, status: e.target.value})
  }
  const updateStatusTimestamp = (e) => {
    setState({...state, timestamp: e})
  }
  const createNewAction = () => {
    createAction({
      data: state.status,
      timestamp: datetime.toJSON(),
      action: "po_history",
      order: order.order.id

    })
  }
  return <Card sx={{padding: 1, minHeight: 100}}>
    <Stack direction="column" sx={{margin: 2}} spacing={2}>
      <Typography variant="h3">Update Status</Typography>
      <TextField label="Status" value={state.status} onChange={ updateStatus } />
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DateTimePicker onChange={updateStatusTimestamp} value={datetime} />
      </LocalizationProvider>
      <ButtonGroup>
        <Button variant="contained" onClick={createNewAction}>Add Record</Button>
      </ButtonGroup>
    </Stack>

  </Card>
}

const POHistoryView = ({order}) => {
  const {data: actions, error, isLoading} = useGetOrderActionsQuery(order.id)

  if (isLoading) {
    return <Loading />
  }
  if (error) {
    return <></>;
  }
  let filtered_actions = actions.objects.filter((action) => {return action.action === "po_history"}).slice().sort((action) => action.timestamp)

  return <Card variant="outlined">
    <Stack direction="column" sx={{margin: 2}} spacing={2}>
      <Typography variant="h2">History</Typography>
      {filtered_actions.map((action, i) =>
          <HistoryItemCard history_item={action} key={action.id}/>
      )}
      <NewHistoryItemCard order={order} />
    </Stack>
  </Card>;
}


const ReadOnlyHistoryItemImages = ({history_item}) => {
  return <Grid container>
      <Grid item>
        {history_item.photos.map((action_image, i) =>
          <HistoryItemImage history_image={action_image} width={210} key={`hii_${action_image.identifier}`}/>
        )}
      </Grid>
    </Grid>
}

const ReadOnlyHistoryItemCard = ({history_item}) => {
  return <Card sx={{padding: 1, minHeight: 100}}>
    <Stack direction="row" spacing={2}>
      <Stack sx={{minWidth: 250}}>
        <Typography variant="h3">{history_item.data}</Typography>
        <Typography variant="subtitle2">{dayjs.utc(history_item.timestamp).local().format('YYYY-MM-DD HH:mm:ss')}</Typography>
      </Stack>
      <Divider orientation="vertical" flexItem></Divider>
      <ReadOnlyHistoryItemImages history_item={history_item}/>
    </Stack>
  </Card>
}


const POHistoryReadOnlyView = ({order}) => {
  let filtered_actions = order.actions.filter((action) => {return action.action === "po_history"}).slice().sort((action) => action.timestamp)
  return <Card>
    <Stack direction="column" sx={{margin: 2}} spacing={2}>
      <Typography variant="h2">Order Progress</Typography>
      {filtered_actions.map((action, i) =>
          <ReadOnlyHistoryItemCard history_item={action} key={action.id}/>
      )}
    </Stack>
  </Card>;
}
export {POHistoryReadOnlyView};
export default POHistoryView;
